
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'How the service works',
    intro:
      'SHOT is a platform where you top up an internal balance, use it to interact with digital content, and receive digital items inside the service.',
    step1Title: 'Topping up the balance',
    step1Text:
      'To start using the service, you top up your internal SHOT balance via the payment methods available on the site.',
    step2Title: 'Using the balance inside the platform',
    step2Text:
      "The topped-up balance is used only inside SHOT. With it you get access to the platform's features and the digital content available in the service.",
    step3Title: 'Opening cases',
    step3Text:
      'After topping up, you can choose and open cases available on the platform. Each case contains digital items that can be obtained by opening it.',
    step4Title: 'Receiving a digital item',
    step4Text:
      'After opening a case, you receive a digital item inside the SHOT platform. The received item is shown in the service interface and becomes available for further actions within the provided functionality.',
    step5Title: 'Further actions with the item',
    step5Intro: "Depending on the platform's available options, you can:",
    step5Item1: 'keep the item inside SHOT;',
    step5Item2: 'sell the item inside SHOT for internal balance;',
    step5Item3:
      'withdraw the item to your own Steam account, if this option is available for the specific item.',
    step6Title: 'Important note',
    step6Text:
      "All main user actions happen inside the SHOT platform through the site interface. The terms of use of the internal balance, digital content, and item withdrawal are determined by the service's rules and functional capabilities.",
  },
  ru: {
    title: 'Как работает сервис',
    intro:
      'SHOT — это платформа, внутри которой пользователь пополняет внутренний баланс, использует его для взаимодействия с цифровым контентом и получает цифровые предметы внутри сервиса.',
    step1Title: 'Пополнение баланса',
    step1Text:
      'Чтобы начать пользоваться сервисом, пользователь пополняет внутренний баланс SHOT через доступные способы оплаты на сайте.',
    step2Title: 'Использование баланса внутри платформы',
    step2Text:
      'Пополненный баланс используется только внутри SHOT. С его помощью пользователь получает доступ к функциям платформы и цифровому контенту, представленному в сервисе.',
    step3Title: 'Открытие кейсов',
    step3Text:
      'После пополнения баланса пользователь может выбирать и открывать кейсы, доступные на платформе. В каждом кейсе представлены цифровые предметы, которые могут быть получены в результате открытия.',
    step4Title: 'Получение цифрового предмета',
    step4Text:
      'После открытия кейса пользователь получает цифровой предмет внутри платформы SHOT. Полученный предмет отображается в интерфейсе сервиса и становится доступен для дальнейших действий в рамках предусмотренного функционала.',
    step5Title: 'Дальнейшие действия с предметом',
    step5Intro: 'В зависимости от доступных возможностей платформы пользователь может:',
    step5Item1: 'оставить предмет внутри SHOT;',
    step5Item2: 'реализовать предмет внутри SHOT за внутренний баланс;',
    step5Item3:
      'вывести предмет на собственный аккаунт Steam, если для конкретного предмета такая возможность доступна.',
    step6Title: 'Важное уточнение',
    step6Text:
      'Все основные действия пользователя происходят внутри платформы SHOT через интерфейс сайта. Условия использования внутреннего баланса, цифрового контента и вывода предметов определяются правилами и функциональными возможностями сервиса.',
  },
  uz: {
    title: 'Xizmat qanday ishlaydi',
    intro:
      'SHOT — bu platforma boʻlib, unda foydalanuvchi ichki balansni toʻldiradi, undan raqamli kontent bilan ishlash uchun foydalanadi va servis ichida raqamli buyumlar oladi.',
    step1Title: 'Balansni toʻldirish',
    step1Text:
      'Xizmatdan foydalanishni boshlash uchun foydalanuvchi saytdagi mavjud toʻlov usullari orqali SHOT ichki balansini toʻldiradi.',
    step2Title: 'Balansdan platforma ichida foydalanish',
    step2Text:
      'Toʻldirilgan balans faqat SHOT ichida ishlatiladi. Uning yordamida foydalanuvchi platforma funksiyalari va servisdagi raqamli kontentga kirish huquqini oladi.',
    step3Title: 'Keyslarni ochish',
    step3Text:
      'Balansni toʻldirgach, foydalanuvchi platformada mavjud keyslarni tanlashi va ochishi mumkin. Har bir keysda ochish natijasida olinishi mumkin boʻlgan raqamli buyumlar mavjud.',
    step4Title: 'Raqamli buyum olish',
    step4Text:
      'Keys ochilgach, foydalanuvchi SHOT platformasi ichida raqamli buyum oladi. Olingan buyum servis interfeysida koʻrsatiladi va koʻzda tutilgan funksional doirasida keyingi harakatlar uchun mavjud boʻladi.',
    step5Title: 'Buyum bilan keyingi harakatlar',
    step5Intro: 'Platformaning mavjud imkoniyatlariga qarab foydalanuvchi:',
    step5Item1: 'buyumni SHOT ichida qoldirishi;',
    step5Item2: 'buyumni SHOT ichida ichki balansga sotishi;',
    step5Item3:
      'agar aniq buyum uchun bunday imkoniyat mavjud boʻlsa, buyumni oʻzining Steam akkauntiga chiqarishi mumkin.',
    step6Title: 'Muhim izoh',
    step6Text:
      'Foydalanuvchining barcha asosiy harakatlari sayt interfeysi orqali SHOT platformasi ichida sodir boʻladi. Ichki balans, raqamli kontent va buyumlarni chiqarish shartlari servis qoidalari va funksional imkoniyatlari bilan belgilanadi.',
  },
  fa: {
    title: 'سرویس چطور کار می‌کند',
    intro:
      'SHOT پلتفرمی است که در آن موجودی داخلی را شارژ می‌کنی، با آن با محتوای دیجیتال کار می‌کنی و داخل سرویس آیتم دیجیتال می‌گیری.',
    step1Title: 'شارژ موجودی',
    step1Text:
      'برای شروع کار با سرویس، موجودی داخلی SHOT را با روش‌های پرداختی که در سایت هست شارژ می‌کنی.',
    step2Title: 'استفاده از موجودی داخل پلتفرم',
    step2Text:
      'موجودی شارژشده فقط داخل SHOT خرج می‌شود. با آن به امکانات پلتفرم و محتوای دیجیتال موجود در سرویس دسترسی پیدا می‌کنی.',
    step3Title: 'باز کردن کیس',
    step3Text:
      'بعد از شارژ می‌توانی کیس‌های موجود در پلتفرم را انتخاب و باز کنی. هر کیس آیتم‌های دیجیتالی دارد که با باز کردن به دست می‌آیند.',
    step4Title: 'دریافت آیتم دیجیتال',
    step4Text:
      'بعد از باز کردن کیس، آیتم دیجیتال را داخل پلتفرم SHOT می‌گیری. آیتم در رابط سرویس نشان داده می‌شود و برای کارهای بعدی در حد امکانات موجود در دسترس است.',
    step5Title: 'کارهای بعدی با آیتم',
    step5Intro: 'بسته به گزینه‌های موجود در پلتفرم می‌توانی:',
    step5Item1: 'آیتم را داخل SHOT نگه داری؛',
    step5Item2: 'آیتم را داخل SHOT بفروشی و موجودی داخلی بگیری؛',
    step5Item3: 'اگر برای آن آیتم ممکن باشد، آن را به حساب استیم خودت برداشت کنی.',
    step6Title: 'نکته مهم',
    step6Text:
      'همه کارهای اصلی کاربر داخل پلتفرم SHOT و از طریق رابط سایت انجام می‌شود. شرایط استفاده از موجودی داخلی، محتوای دیجیتال و برداشت آیتم را قوانین و امکانات سرویس تعیین می‌کنند.',
  },
  pt: {
    title: 'Como o serviço funciona',
    intro:
      'O SHOT é uma plataforma em que o usuário deposita em um saldo interno, usa esse saldo para interagir com conteúdo digital e recebe itens digitais dentro do serviço.',
    step1Title: 'Depósito no saldo',
    step1Text:
      'Para começar a usar o serviço, o usuário deposita no saldo interno do SHOT pelas formas de pagamento disponíveis no site.',
    step2Title: 'Uso do saldo dentro da plataforma',
    step2Text:
      'O saldo depositado é usado só dentro do SHOT. Com ele, o usuário tem acesso às funções da plataforma e ao conteúdo digital oferecido no serviço.',
    step3Title: 'Abertura de caixas',
    step3Text:
      'Depois de depositar, o usuário pode escolher e abrir as caixas disponíveis na plataforma. Cada caixa contém itens digitais que podem ser obtidos ao abri-la.',
    step4Title: 'Recebimento do item digital',
    step4Text:
      'Depois de abrir a caixa, o usuário recebe um item digital dentro da plataforma SHOT. O item recebido aparece na interface do serviço e fica disponível para outras ações dentro das funções previstas.',
    step5Title: 'Outras ações com o item',
    step5Intro: 'Dependendo das opções disponíveis na plataforma, o usuário pode:',
    step5Item1: 'manter o item dentro do SHOT;',
    step5Item2: 'vender o item dentro do SHOT por saldo interno;',
    step5Item3:
      'sacar o item para a própria conta Steam, se essa opção estiver disponível para o item em questão.',
    step6Title: 'Observação importante',
    step6Text:
      'Todas as ações principais do usuário acontecem dentro da plataforma SHOT pela interface do site. As condições de uso do saldo interno, do conteúdo digital e do saque de itens são definidas pelas regras e pelas funcionalidades do serviço.',
  },
  tr: {
    title: 'Servis nasıl çalışır',
    intro:
      'SHOT, kullanıcının iç bakiyesine para yüklediği, bu bakiyeyle dijital içerikle etkileşime girdiği ve servis içinde dijital eşyalar aldığı bir platformdur.',
    step1Title: 'Bakiye yükleme',
    step1Text:
      'Servisi kullanmaya başlamak için kullanıcı, sitedeki mevcut ödeme yöntemleriyle SHOT iç bakiyesine para yükler.',
    step2Title: 'Bakiyenin platform içinde kullanımı',
    step2Text:
      'Yüklenen bakiye yalnızca SHOT içinde kullanılır. Kullanıcı bu bakiyeyle platformun özelliklerine ve serviste sunulan dijital içeriğe erişir.',
    step3Title: 'Kasa açma',
    step3Text:
      'Bakiye yükledikten sonra kullanıcı, platformdaki mevcut kasaları seçip açabilir. Her kasada, açılış sonucunda elde edilebilecek dijital eşyalar bulunur.',
    step4Title: 'Dijital eşyanın alınması',
    step4Text:
      'Kasa açıldıktan sonra kullanıcı, SHOT platformu içinde bir dijital eşya alır. Alınan eşya servis arayüzünde görünür ve sunulan işlevler kapsamında sonraki işlemler için kullanılabilir hale gelir.',
    step5Title: 'Eşyayla yapılabilecek sonraki işlemler',
    step5Intro: 'Platformun mevcut olanaklarına bağlı olarak kullanıcı:',
    step5Item1: 'eşyayı SHOT içinde tutabilir;',
    step5Item2: 'eşyayı SHOT içinde iç bakiye karşılığında satabilir;',
    step5Item3:
      'söz konusu eşya için bu seçenek mevcutsa eşyayı kendi Steam hesabına çekebilir.',
    step6Title: 'Önemli not',
    step6Text:
      'Kullanıcının tüm temel işlemleri SHOT platformu içinde, site arayüzü üzerinden gerçekleşir. İç bakiyenin, dijital içeriğin ve eşya çekiminin kullanım koşulları servisin kuralları ve işlevsel olanaklarıyla belirlenir.',
  },
  uk: {
    title: 'Як працює сервіс',
    intro:
      'SHOT — це платформа, всередині якої ти поповнюєш внутрішній баланс, використовуєш його для взаємодії з цифровим контентом і отримуєш цифрові предмети всередині сервісу.',
    step1Title: 'Поповнення балансу',
    step1Text:
      'Щоб почати користуватися сервісом, ти поповнюєш внутрішній баланс SHOT через доступні способи оплати на сайті.',
    step2Title: 'Використання балансу всередині платформи',
    step2Text:
      "Поповнений баланс використовується лише всередині SHOT. З його допомогою ти отримуєш доступ до функцій платформи та цифрового контенту, представленого в сервісі.",
    step3Title: 'Відкриття кейсів',
    step3Text:
      'Після поповнення балансу ти можеш обирати й відкривати кейси, доступні на платформі. У кожному кейсі представлені цифрові предмети, які можна отримати внаслідок відкриття.',
    step4Title: 'Отримання цифрового предмета',
    step4Text:
      'Після відкриття кейса ти отримуєш цифровий предмет усередині платформи SHOT. Отриманий предмет відображається в інтерфейсі сервісу та стає доступним для подальших дій у межах передбаченого функціоналу.',
    step5Title: 'Подальші дії з предметом',
    step5Intro: "Залежно від доступних можливостей платформи ти можеш:",
    step5Item1: 'залишити предмет усередині SHOT;',
    step5Item2: 'реалізувати предмет усередині SHOT за внутрішній баланс;',
    step5Item3:
      'вивести предмет на власний акаунт Steam, якщо для конкретного предмета така можливість доступна.',
    step6Title: 'Важливе уточнення',
    step6Text:
      "Усі основні дії користувача відбуваються всередині платформи SHOT через інтерфейс сайту. Умови використання внутрішнього балансу, цифрового контенту та виведення предметів визначаються правилами й функціональними можливостями сервісу.",
  },
  de: {
    title: 'So funktioniert der Service',
    intro:
      'SHOT ist eine Plattform, auf der du ein internes Guthaben aufladest, damit mit digitalen Inhalten interagierst und digitale Items im Service erhältst.',
    step1Title: 'Guthaben aufladen',
    step1Text:
      'Um den Service zu nutzen, lädst du dein internes SHOT-Guthaben über die auf der Seite verfügbaren Zahlungsmethoden auf.',
    step2Title: 'Guthaben innerhalb der Plattform nutzen',
    step2Text:
      "Das aufgeladene Guthaben gilt nur innerhalb von SHOT. Damit bekommst du Zugriff auf die Funktionen der Plattform und die digitalen Inhalte des Services.",
    step3Title: 'Cases öffnen',
    step3Text:
      'Nach dem Aufladen kannst du die verfügbaren Cases der Plattform auswählen und öffnen. Jeder Case enthält digitale Items, die du beim Öffnen erhalten kannst.',
    step4Title: 'Digitales Item erhalten',
    step4Text:
      'Nach dem Öffnen eines Cases erhältst du ein digitales Item auf der SHOT-Plattform. Das erhaltene Item wird in der Oberfläche des Services angezeigt und steht für weitere Aktionen im Rahmen der vorgesehenen Funktionen bereit.',
    step5Title: 'Weitere Aktionen mit dem Item',
    step5Intro: "Je nach den verfügbaren Möglichkeiten der Plattform kannst du:",
    step5Item1: 'das Item in SHOT behalten;',
    step5Item2: 'das Item in SHOT gegen internes Guthaben verkaufen;',
    step5Item3:
      'das Item auf dein eigenes Steam-Konto auszahlen lassen, sofern das für das jeweilige Item möglich ist.',
    step6Title: 'Wichtiger Hinweis',
    step6Text:
      "Alle wichtigen Aktionen laufen innerhalb der SHOT-Plattform über die Oberfläche der Seite. Die Nutzungsbedingungen für das interne Guthaben, digitale Inhalte und die Auszahlung von Items richten sich nach den Regeln und Funktionen des Services.",
  },
  es: {
    title: 'Cómo funciona el servicio',
    intro:
      'SHOT es una plataforma en la que recargas un saldo interno, lo usas para interactuar con contenido digital y recibes objetos digitales dentro del servicio.',
    step1Title: 'Recarga del saldo',
    step1Text:
      'Para empezar a usar el servicio, recargas tu saldo interno de SHOT con los métodos de pago disponibles en el sitio.',
    step2Title: 'Uso del saldo dentro de la plataforma',
    step2Text:
      "El saldo recargado se usa solo dentro de SHOT. Con él accedes a las funciones de la plataforma y al contenido digital disponible en el servicio.",
    step3Title: 'Apertura de cajas',
    step3Text:
      'Tras recargar el saldo, puedes elegir y abrir las cajas disponibles en la plataforma. Cada caja contiene objetos digitales que puedes obtener al abrirla.',
    step4Title: 'Obtención de un objeto digital',
    step4Text:
      'Tras abrir una caja, recibes un objeto digital dentro de la plataforma SHOT. El objeto recibido se muestra en la interfaz del servicio y queda disponible para otras acciones dentro de la funcionalidad prevista.',
    step5Title: 'Qué puedes hacer después con el objeto',
    step5Intro: "Según las opciones disponibles en la plataforma, puedes:",
    step5Item1: 'dejar el objeto dentro de SHOT;',
    step5Item2: 'vender el objeto dentro de SHOT a cambio de saldo interno;',
    step5Item3:
      'retirar el objeto a tu propia cuenta de Steam, si esa opción está disponible para ese objeto.',
    step6Title: 'Aclaración importante',
    step6Text:
      "Todas las acciones principales del usuario ocurren dentro de la plataforma SHOT, a través de la interfaz del sitio. Las condiciones de uso del saldo interno, del contenido digital y de la retirada de objetos las determinan las reglas y las funciones del servicio.",
  },
  pl: {
    title: 'Jak działa serwis',
    intro:
      'SHOT to platforma, na której doładowujesz wewnętrzne saldo, używasz go do interakcji z cyfrową zawartością i otrzymujesz cyfrowe przedmioty wewnątrz serwisu.',
    step1Title: 'Doładowanie salda',
    step1Text:
      'Żeby zacząć korzystać z serwisu, doładowujesz wewnętrzne saldo SHOT dostępnymi na stronie metodami płatności.',
    step2Title: 'Użycie salda wewnątrz platformy',
    step2Text:
      "Doładowane saldo jest używane tylko wewnątrz SHOT. Dzięki niemu masz dostęp do funkcji platformy i cyfrowej zawartości dostępnej w serwisie.",
    step3Title: 'Otwieranie skrzynek',
    step3Text:
      'Po doładowaniu salda możesz wybierać i otwierać skrzynki dostępne na platformie. W każdej skrzynce są cyfrowe przedmioty, które możesz zdobyć po jej otwarciu.',
    step4Title: 'Otrzymanie cyfrowego przedmiotu',
    step4Text:
      'Po otwarciu skrzynki otrzymujesz cyfrowy przedmiot wewnątrz platformy SHOT. Otrzymany przedmiot widać w interfejsie serwisu i możesz z nim dalej działać w ramach dostępnych funkcji.',
    step5Title: 'Dalsze działania z przedmiotem',
    step5Intro: "W zależności od dostępnych możliwości platformy możesz:",
    step5Item1: 'zostawić przedmiot w SHOT;',
    step5Item2: 'sprzedać przedmiot w SHOT za wewnętrzne saldo;',
    step5Item3:
      'wypłacić przedmiot na własne konto Steam, jeśli dla danego przedmiotu jest taka możliwość.',
    step6Title: 'Ważne zastrzeżenie',
    step6Text:
      "Wszystkie główne działania użytkownika odbywają się wewnątrz platformy SHOT przez interfejs strony. Zasady korzystania z wewnętrznego salda, cyfrowej zawartości i wypłaty przedmiotów określają reguły i funkcjonalne możliwości serwisu.",
  },
});
